const custMap = new Map([
    ['00000000', '104'],
    [16861784, '華苓'],
    [53258865, '亞家'],
    [53435258, '新北都'],
    [53397395, '大醫'],
    [59209167, '加雲聯網'],
    [24765568, '巨生生醫'],
    [82864003, '比旺'],
    [12673852, '聯合通商'],
    [78949249, '信望愛'],
    [12377493, '康大'],
    [28138744, '佳源'],
    [25124529, '潤雅'],
    [42614780, '台灣王知'],
    [75169606, '旭光'],
    [56653880, '竣驜'],
    [55754798, '聯創'],
    [13023033, '聯宙'],
    [80397762, '德易力'],
    [27619977, '應廣'],
    [22332192, '承啟'],
    [31913298, '好心肝'],
    [54269279, '虹晶'],
    [90146815, '宇博'],
    [24626237, '天加'],
    [16376782, '文偉'],
    [24770801, '群健'],
    [96904997, '台灣京瓷'],
    [96967747, '福城'],
    [83237570, '福澤'],
    [22092003, '協欣'],
    [27946233, '遠雄巨蛋'],
    [86687839, '信宇'],
    [22368753, '頂呱呱'],
    [35882520, '中華電線'],
    [56676244, '港洲營造'],
    [70461075, '神坊資訊'],
    [31300690, '王佳實業']
]);

const custMenu = {
    ZZ: {
        shortName: ['外掛', 'plug-in.', '外挂'],
        name: ['外掛', 'plug-in', '外挂'],
        ico: 'suitcase',
        hint: [],
        children: {
            ZZ_SSO: {
                name: [
                    `SSO(${custMap.get('00000000') ? custMap.get('00000000') : '00000000'})`,
                    `SSO(${custMap.get('00000000') ? custMap.get('00000000') : '00000000'})`,
                    `SSO(${custMap.get('00000000') ? custMap.get('00000000') : '00000000'})`
                ],
                children: {
                    ZZ_SSO: {
                        name: ['SSO', 'SSO', 'SSO'],
                        url: '/zz_sso',
                        hint: [],
                    }
                },
            },
            ZZ_00000000: {
                name: [
                    `出勤(${custMap.get('00000000') ? custMap.get('00000000') : '00000000'})`,
                    `Attendance hours(${custMap.get('00000000') ? custMap.get('00000000') : '00000000'})`,
                    `出勤(${custMap.get('00000000') ? custMap.get('00000000') : '00000000'})`
                ],
                children: {
                    ZZ_COMMON_PB10010: {
                        name: ['薪資平測差異表', '(客製)Salary difference table', '(客製)薪资平测差异表'],
                        url: '/zz_common_pb10010',
                        hint: [],
                    },
                    ZZ_COMMON_PB10011: {
                        name: ['獎金平測差異表', '(客製)Bonus difference table', '(客製)奖金平测差异表'],
                        url: '/zz_common_pb10011',
                        hint: [],
                    },
                },
            },
            ZZ_22368753: {
                name: [
                    `出勤(${custMap.get(22368753) ? custMap.get(22368753) : '22368753'})`,
                    `Attendance hours(${custMap.get(22368753) ? custMap.get(22368753) : '22368753'})`,
                    `出勤(${custMap.get(22368753) ? custMap.get(22368753) : '22368753'})`
                ],
                children: {
                    ZZ_COMMON_AM10010: {
                        name: ['(客製)出勤模擬試算', '(客製)Attendance Simulation', '(客製)出勤模拟试算'],
                        url: '/zz_common_am10010',
                        hint: [],
                    }
                },
            },
            ZZ_42614780: {
                name: [
                    `出勤時數(${custMap.get(42614780) ? custMap.get(42614780) : '42614780'})`,
                    `Attendance hours(${custMap.get(42614780) ? custMap.get(42614780) : '42614780'})`,
                    `出勤时数(${custMap.get(42614780) ? custMap.get(42614780) : '42614780'})`
                ],
                children: {
                    ZZ_KINGSKNOW_AM50035: {
                        name: ['(客製)排班轉出勤時數', '(客製)Shift shift to attendance hours', '(客製)排班转出勤时数'],
                        url: '/zz_kingsknow_am50035',
                        hint: [],
                    },
                },
            },
            ZZ_75169606: {
                name: [
                    `薪資報表(${custMap.get(75169606) ? custMap.get(75169606) : '75169606'})`,
                    `Salary report(${custMap.get(75169606) ? custMap.get(75169606) : '75169606'})`,
                    `薪资报表(${custMap.get(75169606) ? custMap.get(75169606) : '75169606'})`
                ],
                children: {
                    ZZ_SYUGUANG_PB00101: {
                        name: ['(客製)薪資明細表表頭設定', '(客製)Salary statement header setup', '(客製)薪资明细表表头设置'],
                        url: '/zz_common_pb10020',
                        hint: [],
                        ZZ_SYUGUANG_PB00101: { name: ['(客製)薪資明細表表頭設定', '(客製)Salary statement header setup', '(客製)薪资明细表表头设置'] },
                    },
                    ZZ_SYUGUANG_PB00102: {
                        name: ['(客製)薪資報表', '(客製)Salary report', '(客製)薪资报表'],
                        url: '/zz_common_pb10021',
                        hint: [],
                        ZZ_SYUGUANG_PB00102: { name: ['(客製)薪資報表', '(客製)Salary report', '(客製)薪资报表'] }, 
                    },                  
                },
            },
            ZZ_27946233: {
                name: [
                    `代碼維護(${custMap.get(27946233) ? custMap.get(27946233) : '27946233'})`,
                    `Parameters(${custMap.get(27946233) ? custMap.get(27946233) : '27946233'})`,
                    `代码维护(${custMap.get(27946233) ? custMap.get(27946233) : '27946233'})`
                ],
                children: {
                    ZZ_FARGLORYDOME_PB10710_RCCC: {
                        name: ['(客製)成本中心','(客製)Cost Center','(客製)成本中心'],
                        url: '/zz_farglorydome_pb10710_rccc',
                        hint: [],
                        ZZ_FARGLORYDOME_PB10710_RCCC: { name: ['(客製)成本中心','(客製)Cost Center','(客製)成本中心'] },
                    },          
                },
            },
            ZZ_12377493: {
                name: [
                    `報表(${custMap.get(12377493) ? custMap.get(12377493) : '12377493'})`,
                    `Report(${custMap.get(12377493) ? custMap.get(12377493) : '12377493'})`,
                    `报表(${custMap.get(12377493) ? custMap.get(12377493) : '12377493'})`
                ],
                children: {
                    ZZ_KANGDA_REPORT: {
                        name: ['(客製)報表','(客製)Report','(客製)报表'],
                        url: '/zz_kangda_report',
                        hint: [],
                    },          
                },
            },
            ZZ_35882520: {
                name: [
                    `傳票(${custMap.get(35882520) ? custMap.get(35882520) : 35882520})`,
                    `Accountting(${custMap.get(35882520) ? custMap.get(35882520) : 35882520})`,
                    `传票(${custMap.get(35882520) ? custMap.get(35882520) : 35882520})`
                ],
                children: {
                    ZZ_COMMON_PB10030: {
                        name: ['(客製)傳票設定', '(客製)Accountting Settings', '(客制)传票设定'],
                        url: '/zz_common_pb10030',
                        hint: [],
                    },
                    ZZ_COMMON_PB10031: {
                        name: ['(客製)傳票匯出', '(客製)Accountting Export', '(客制)传票汇出'],
                        url: '/zz_common_pb10031',
                        hint: [],
                    },
                },
            },   
            ZZ_56676244: {
                name: [
                    `出勤(${custMap.get(56676244) ? custMap.get(56676244) : '56676244'})`,
                    `Attendance hours(${custMap.get(56676244) ? custMap.get(56676244) : '56676244'})`,
                    `出勤(${custMap.get(56676244) ? custMap.get(56676244) : '56676244'})`
                ],
                children: {
					ZZ_KONGCHOU_WF10011: {
						name: ['(客製)請假提出核准天數設定','(Customize)Leave Approval Days','(客制)请假提出核准天数设定'],
						url: '/zz_kongchou_wf10011',
						hint: [],
					},
                    ZZ_KONGCHOU_WF10020: {
                        name: ['(客製)加班單次數限制設定','(客製)Overtime limit','(客制)加班单次数限制设置'],
                        url: '/zz_kongchou_wf10020',
                        hint: [],
                    },          
                },
            },   
            ZZ_31300690: {
                name: [
                    `薪資(${custMap.get(31300690) || '31300690'})`,
                    `Salary(${custMap.get(31300690) || '31300690'})`,
                    `薪资(${custMap.get(31300690) || '31300690'})`,
                ],
                children: {
                    ZZ_PB_SECTION_ALLOWANCE_CARDTIME: {
                        name: ['(客製)輪班津貼計算', '(Customize)Allowance Calculation', '(客制)轮班津贴计算'],
                        url: '/zz_pb_section_allowance_cardtime',
                        hint: [],
                    },
                },
            },   
        },
    },
};

module.exports = (paidMenu) => {
    return { ...paidMenu, ...custMenu };
};